export default __webpack_public_path__ + "static/media/parlamentia.f187c258.svg";